import { observable, computed, action } from 'mobx'
import range from 'lodash/range'

export default class TaxYearsState {
  stepId = 'TaxYears'
  title = 'What year(s) are you filing taxes?'
  trackingId = 'Onboarding - Year Selection'

  @observable years

  constructor ({ wizard }) {
    this.wizard = wizard

    // This year + 5 years back.
    const thisYear = new Date().getFullYear()
    this.years = range(1, 6).map(
      (i) => new Year(thisYear - i)
    )
  }

  @computed get nextEnabled () {
    return this.selectedYears.length > 0
  }

  @computed get selectedYears () {
    return this.years.filter(x => x.selected)
  }

  @computed get relevant () {
    const step = this.wizard.getStep('ProjectType')
    if (!step) {
      return false
    }

    if (!step.legend) {
      return false
    }

    return ['PERSONAL_QUARTERLY_ESTIMATES', 'BUSINESS_QUARTERLY_ESTIMATES'].includes(step.legend.id) === false
  }

  serializeToJob () {
    return {
      years: this.selectedYears.map(x => x.year)
    }
  }

  hydrate (job) {
    if (job.years) {
      this.years.forEach(y => job.years.indexOf(y.year) > -1 && y.setSelected(true))
    }
  }
}

/**
 * Used in a checklist.
 */
class Year {
  @observable year = 0
  @observable selected = false

  constructor (year) {
    this.year = year
  }

  @action setSelected (selected) {
    this.selected = selected
  }
}



// WEBPACK FOOTER //
// ./src/client/screens/ProjectWizard/Steps/TaxYears/TaxYearsState.js